




























































































































































































































import {Component, Vue, Watch} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import CommonInputMixin from '../../mixins/common_input';
import {DxScrollView} from 'devextreme-vue';
import HeaderSet from '@/components/HeaderSet/HeaderSet.vue';
import BlockCard from '@/components/InputComponents/block-card.vue';
import BlockInputs from '@/components/InputComponents/block-inputs.vue';
import TotalBlockInputs from '@/components/InputComponents/block-inputs-new.vue';
import CardHeader from '@/components/InputComponents/card-header.vue'
import InputsHeader from '@/components/InputComponents/inputs-header.vue';
import RowInputs from '@/components/InputComponents/row-inputs.vue';
import RowInputsNew from '@/components/InputComponents/row-inputs-new.vue';
import RowCard from '@/components/InputComponents/row-card.vue';
import PresetService from '@/services/user_preset_service';
import dicts_cache_service from '@/services/dicts_cache_service';
import {
  Contractor,
  Purchase,
  PurchaseTotal,
  Tariff,
  UniversalData,
  UserPreset,
  Accept,
  AcceptData
} from '@/services/models-service';
import PurchasesInputService from '@/services/purchases_input_service';
import ContractorService from "@/services/contractor-service";
import TariffService from "@/services/tariff-service";
import _ from 'lodash';
import {HeatCarrier} from '@/services/data/heat_carrier_service';
import {aggregate_periods, months_dict, periods} from '@/constants';
import acceptService from '@/services/accept-service';
import {tariffWarmEnergy, tariffWarmPower} from "@/constants";
import {alert, confirm} from 'devextreme/ui/dialog';
import UserAccessService from '@/services/user_access_service';
import {DxLoadPanel} from 'devextreme-vue/load-panel';
import DxDrawer from 'devextreme-vue/drawer';
import AggregatedRow from '@/components/InputComponents/aggregated-row.vue';
import SimpleChoicePopup from '@/components/InputComponents/simple-choice-popup.vue';
import ExcelPasteHint from '@/components/ExcelPasteHint/index.vue';
import CutService from '@/services/cut-service';
import ImbalanceTable from "@/components/InputComponents/imbalance-table.vue";
import ResizeObserver from 'resize-observer-polyfill';
import choicePopup from "@/components/InputComponents/choice-popup.vue";
import choiceRecalcPopup from "@/components/InputComponents/choice-recalc-popup.vue";


@Component({
  name: 'Purchase',
  components: {
    ImbalanceTable,
    DxScrollView,
    HeaderSet,
    BlockCard,
    RowInputsNew,
    TotalBlockInputs,
    InputsHeader,
    RowInputs,
    RowCard,
    CardHeader,
    DxLoadPanel,
    DxDrawer,
    AggregatedRow,
    SimpleChoicePopup,
    ExcelPasteHint,
    choicePopup,
    choiceRecalcPopup,
  }
})

export default class extends mixins(CommonInputMixin) {
  public facilityName: string = '';

  public service = PurchasesInputService;
  public block_dict = dicts_cache_service.purchase_blocks;
  public period_ds = dicts_cache_service.periods;
  public showBlocks: any[] = [];

  public header = 'Продавец';
  public totalBlockHeader = [{display: 'Покупки', name: 'total'}]
  public startLoading: boolean = false;
  public tableStructureReady: boolean = false;
  public disableSave: boolean = true;

  //названия срезок для inputs-header
  public mainCutName: string = '';
  public secondaryCutName: string = '';

  //Данные страницы
  public all_purchase_data: any = [];
  public purchaseData: any = {};
  public all_total_data: any = [];

  public all_secondary: any = [];
  public secondaryData: any = {};
  public all_secondary_total: any = [];
  public removeList: Purchase[] = [];

  public allContractor: Contractor[] = [];
  public allSecondaryContractor: Contractor[] = [];
  public allTariffs: Tariff[] = [];
  public viewTariffs: Tariff[] = [];
  public viewPrices: Tariff[] = [];
  public allSecondaryTariffs: Tariff[] = [];
  public tariffs: { [key: string]: any; } = {};
  public secondaryTariffs: { [key: string]: any; } = {};
  public allHeatCarrier: HeatCarrier[] = [];
  public tariffWarmEnergy: any = tariffWarmEnergy;
  public tariffWarmPower: any = tariffWarmPower;

  public currentObject: number | null = null;
  public currentAccept: any = {};
  public acceptPeriods: any = {};
  public disableTarif: boolean = false;
  public disableVolume: boolean = false;

  //суммирование
  public totalCount: any = {};

  public loading_animation: boolean = false;
  public showExcelHint: boolean = false;

  // Свойства для контроля вставки данных
  public globalPasteData: number[][] | null = null;
  public globalPasteStartRow: number = 0;
  public globalPasteStartCol: number = 0;
  public globalPasteTargetBlock: string | null = null;
  public globalPasteTargetPeriod: string | null = null;
  public globalPasteFocusedColumn: string | null = null;
  public allowEditTariff: boolean = false;
  public allowEditVolume: boolean = false;
  public allowAddRows: boolean = false;
  public showPowerColumns: boolean = false;

  public strictTariffCalc: boolean = false;

  public needRecalc: number | null = null;
  public choiсe: string | null = null;
  public tariffForRollback: string = '';

  public imbalanceStruct: any = {};

  public headerHeight: any = 0;
  public arrowHeight: any = 0;

  // === ПЕРЕМЕННЫЕ ДЛЯ ОТСЛЕЖИВАНИЯ ШИРИНЫ inputs-header ===
  public inputsHeaderWidth: number = 0;
  private inputsHeaderObservers: Map<string, ResizeObserver> = new Map();
  private inputsHeaderWidths: Map<string, number> = new Map();
  // ========================================================

  public cardHeaderWidth: number = 0;
  private cardHeaderObserver: ResizeObserver | null = null;


  public changesArray: any[] = [];
  public changesLengthBeforePaste: number = 1;

  public changeStatus: string = '';
  public popupVisible: boolean = false;

  public oldData: any = {};
  public isRowMoved: boolean = false
  public isRowAdded: boolean = false

  @Watch('changesArray')
  onChangesArrayUpdated() {
    console.log("changesArray updated", this.changesArray);
    console.log("changesLengthBeforePaste", this.changesLengthBeforePaste);
    this.updatePopupVisibility();
  }

  private updatePopupVisibility(): void {
    this.popupVisible =
      this.changesArray.length > 0 &&
      this.changesLengthBeforePaste !== 0 &&
      !this.isRowMoved &&
      !this.isRowAdded;
  }

  private clearRecalcPopupState(): void {
    this.changesArray = [];
    this.changesLengthBeforePaste = 1;
    this.currentChangeIndex = 0;
    this.changeStatus = '';
    this.popupVisible = false;
  }

  onMove(){
      this.isRowMoved = true
      this.$root.$emit('row-moving-start');
      this.$nextTick(() => {
        setTimeout(() => {
          this.$root.$emit('row-moving-end');
          this.isRowMoved = false;
          this.updatePopupVisibility();
        }, 200);
      });
    }

    onAddRow(blockName: string, preset: UserPreset) {
      this.isRowAdded = true
      this.$root.$emit('row-moving-start');
      this.addNewData(blockName, preset)
      this.$nextTick(() => {
        setTimeout(() => {
          this.$root.$emit('row-moving-end');
          this.isRowAdded = false;
          this.updatePopupVisibility();
        }, 200);
      });
    }

    updateOldDataOnSelectChange(eventData: { block: string, index: number, data: any }) {
      const { block, index, data } = eventData;
      // Обновляем oldData для всех месяцев этой строки
      this.months.forEach((month: string) => {
        if (!this.oldData[block]) {
          this.oldData[block] = {};
        }
        if (!this.oldData[block][month]) {
          this.oldData[block][month] = [];
        }
        const oldDataBlock = this.oldData[block][month][index];
        if (oldDataBlock) {
          // Обновляем существующую запись
          const currentData = this.purchaseData[block][month][index];
          if (currentData) {
            Object.assign(oldDataBlock, _.cloneDeep(currentData));
          }
        } else {
          // Если записи нет, добавляем её
          const currentData = this.purchaseData[block][month][index];
          if (currentData) {
            this.oldData[block][month][index] = _.cloneDeep(currentData);
          }
        }
      });
    }

  public currentChangeIndex: number = 0; // индекс текущего отображаемого попапа

  // Computed property для отображения только одного попапа:
  get currentChange() {
    if (this.currentChangeIndex >= 0 && this.currentChangeIndex < this.changesArray.length && this.currentChangeIndex < this.changesLengthBeforePaste) {
      return this.changesArray[this.currentChangeIndex];
    }
    return null;
  }

  // Метод для запуска обработки очереди попапов:
  processChangesQueue() {
    if (this.changesArray.length > 0) {
      this.currentChangeIndex = 0; // Начинаем с первого
    }
  }

  // Метод-обработчик закрытия попапа (добавьте @close или подобное событие):
  onChangePopupClose(data: any) {
    const currentDataIndex = this.purchaseData[data.block][data.month].findIndex((item: any) => item.id === data.id);
    if (currentDataIndex >= 0){
      this.purchaseData[data.block][data.month][currentDataIndex] = data;
    }
    this.currentChangeIndex++; // Переходим к следующему

    // Если закончились попапы - сбрасываем индекс
    this.$nextTick(() => {
      if (this.currentChangeIndex >= this.changesArray.length || this.currentChangeIndex >= this.changesLengthBeforePaste ) {
        this.currentChangeIndex = 0;
        this.changesArray = []; // Очищаем массив изменений после обработки всех
        this.changesLengthBeforePaste = 1;
      }
    });

  }

  mounted() {
    const headerEl = this.$refs.header as HTMLElement;
    const arrowEl = this.$refs.arrow as HTMLElement;
    if (headerEl && arrowEl) {
      this.headerHeight = `calc(100% - ${(headerEl.clientHeight + arrowEl.clientHeight)}px)`;
      this.arrowHeight = `calc(100% - ${arrowEl.clientHeight}px)`;
      console.log("Header height:", headerEl.clientHeight);
    }

    this.$nextTick(() => {
      this.initializeInputsHeaderTracking();
      this.initializeCardHeaderTracking();
    });
  }

  beforeDestroy() {
    this.cleanupInputsHeaderObservers();
    this.cleanupCardHeaderObserver();
  }

  // === МЕТОДЫ ОТСЛЕЖИВАНИЯ ШИРИНЫ ===

  private initializeInputsHeaderTracking(): void {
    if (!this.selected_periods || this.selected_periods.length === 0) {
      console.warn('Selected periods not available for inputs-header width tracking');
      return;
    }

    this.selected_periods.forEach((period: string) => {
      this.setupInputsHeaderObserver(period);
    });
  }

  private setupInputsHeaderObserver(period: string): void {
    try {
      const refName = `inputsHeader_${period}`;
      const refElement = (this.$refs[refName] as any);

      if (!refElement || !Array.isArray(refElement) || refElement.length === 0) {
        console.warn(`Element ref ${refName} not found or is not an array`);
        return;
      }

      const element = refElement[0] as HTMLElement;

      if (!element) {
        console.warn(`Could not access element from ref ${refName}`);
        return;
      }

      if (this.inputsHeaderObservers.has(period)) {
        this.inputsHeaderObservers.get(period)?.disconnect();
      }

      const observer = new ResizeObserver((entries: ResizeObserverEntry[]) => {
        entries.forEach((entry: ResizeObserverEntry) => {
          const width = entry.contentRect.width;

          this.inputsHeaderWidths.set(period, width);

          if (!this.inputsHeaderWidth || this.selected_periods[0] === period) {
            this.inputsHeaderWidth = width;
          }

          this.onInputsHeaderWidthChanged(period, width);
        });
      });

      observer.observe(element);
      this.inputsHeaderObservers.set(period, observer);

      const initialWidth = element.offsetWidth;
      this.inputsHeaderWidths.set(period, initialWidth);

      if (!this.inputsHeaderWidth || this.selected_periods[0] === period) {
        this.inputsHeaderWidth = initialWidth;
      }

      console.log(`Initial inputs-header width for period "${period}": ${initialWidth}px`);

    } catch (error) {
      console.error(`Error setting up observer for period "${period}":`, error);
    }
  }

  private onInputsHeaderWidthChanged(period: string, width: number): void {
    // Логика при изменении ширины
  }

  getInputsHeaderWidthByPeriod(period: string): number {
    return this.inputsHeaderWidths.get(period) || 0;
  }

  getAllInputsHeaderWidths(): Record<string, number> {
    const result: Record<string, number> = {};
    this.inputsHeaderWidths.forEach((width: number, period: string) => {
      result[period] = width;
    });
    return result;
  }

  reinitializeInputsHeaderTracking(): void {
    this.cleanupInputsHeaderObservers();
    this.$nextTick(() => {
      this.initializeInputsHeaderTracking();
    });
  }

  private cleanupInputsHeaderObservers(): void {
    this.inputsHeaderObservers.forEach((observer: ResizeObserver) => {
      observer.disconnect();
    });
    this.inputsHeaderObservers.clear();
    this.inputsHeaderWidths.clear();
    this.inputsHeaderWidth = 0;
  }

  // === КОНЕЦ МЕТОДОВ ОТСЛЕЖИВАНИЯ ШИРИНЫ ===

  private initializeCardHeaderTracking(): void {
    this.$nextTick(() => {
      this.setupCardHeaderObserver();
    });
  }

  private setupCardHeaderObserver(): void {
    try {
      const cardHeaderElement = this.$refs.cardHeaderContainer as HTMLElement;

      if (!cardHeaderElement) {
        console.warn('Card header container element not found');
        return;
      }

      if (this.cardHeaderObserver) {
        this.cardHeaderObserver.disconnect();
      }

      const observer = new ResizeObserver((entries: ResizeObserverEntry[]) => {
        entries.forEach((entry: ResizeObserverEntry) => {
          const width = entry.contentRect.width;
          this.cardHeaderWidth = width;
        });
      });

      observer.observe(cardHeaderElement);
      this.cardHeaderObserver = observer;

      const initialWidth = cardHeaderElement.offsetWidth;
      if (initialWidth > 0) {
        this.cardHeaderWidth = initialWidth;
      }

      console.log(`Initial card-header width: ${initialWidth}px`);

    } catch (error) {
      console.error('Error setting up card-header observer:', error);
    }
  }

  private cleanupCardHeaderObserver(): void {
    if (this.cardHeaderObserver) {
      this.cardHeaderObserver.disconnect();
      this.cardHeaderObserver = null;
    }
    this.cardHeaderWidth = 0;
  }


  handleImbalance(data: any): void {
    this.imbalanceStruct = data
  }

  // handleShowImbalance(val: boolean): void {
  //   this.isImbalanceVisible = val;
  // }

  async exportData() {
    const exportFilter = this.preset_service.createExportToExcelFilterObject(this.route || undefined);
    if (exportFilter) {
      await this.service.exportToExcel(exportFilter,
        this.mainCutName ? `Покупка_${this.mainCutName.replace(' ', '_')}_${exportFilter.id_eco_facility}` : null)
    }
  }

  async onSave() {
    try {
      this.loading_animation = true;
      this.disableSave = true;

      let pack: Purchase[] = [];
      //преобразуем данные строк в массив объектов для отправки на бэк
      for (let block in this.purchaseData) {
        for (let period in this.purchaseData[block]) {
          if (this.aggregatePeriods.includes(period)) {
            continue;
          }
          for (let row in this.purchaseData[block][period]) {
            const purchase = this.purchaseData[block][period][row];
            if (block !== "vno" || (purchase.vol_te >= 0 && purchase.vol_power >= 0 && purchase.cost_te >= 0 && purchase.cost_power >= 0 &&
              purchase.id_tarif && this.tariffs[purchase.id_tarif] &&
              this.tariffs[purchase.id_tarif][this.tariffWarmEnergy[period]] >= 0 &&
              this.tariffs[purchase.id_tarif][this.tariffWarmPower[period]] >= 0)) {

              delete this.purchaseData[block][period][row].isFocused;
              pack.push(this.purchaseData[block][period][row])

            } else {
              const buy_block = dicts_cache_service.purchase_blocks.find((x: any) => x.name === block);

              if (buy_block) {
                alert(`Попытка сохранить недопустимые значения для блока \"${buy_block.display}\" - месяц \"${months_dict[period]}\"`, 'Ошибка');
              } else {
                alert(`Попытка сохранить недопустимые значения для блока \"${block}\" - месяц \"${months_dict[period]}\"`, 'Ошибка');
              }

              this.loading_animation = false;
              this.disableSave = false;
              return;
            }
          }
        }
      }

      if (pack.length > 0) await this.service.save(pack);
      //Удаление данных
      if (this.removeList.length > 0) {
        await this.service.delete(this.removeList);
        this.removeList = [];
        this.clearRecalcPopupState();
      }

      await this.getSavedData(this.changed, this.purchaseData, this.service.getWithFilter, this.tariffs);
      await this.getSavedTotalData(this.changed, this.service.getChangedTotal);
      this.changed = [];
      this.changedData = {}
      this.preset_service.setPowerAfterLoading(this.showPowerColumns);
    } catch (error) {
      console.log(error)
    } finally {
      this.loading_animation = false;
      if (this.changed.length) {
        this.disableSave = false;
      }
    }
  }

  async getLoad() {
    this.showNoBlocks = false;
    this.showNoTariffs = false;
    this.clearRecalcPopupState();
    if (this.changed.length > 0 && !this.forceReload) {
      const answer = await confirm('Имеются несохранённые изменения. Сохранить?', 'Сохранение')
      if (answer) {
        await this.onSave();
      } else {
        this.changed = [];
      }
    }
    if (!this.showBlocks?.length) {
      this.loading_animation = false;
      this.tableStructureReady = false;
      this.showNoBlocks = true;
      return
    }
    let newDate = new Date();

    this.initSecondary = true;
    this.startLoading = false;
    this.showPowerColumns = false;
    this.loading_animation = true;

    this.listToAggregate = [];
    this.aggregatePeriods = [];

    this.changedData = {};
    this.acceptPeriods = {};
    this.all_secondary = [];
    this.all_secondary_total = [];
    this.all_purchase_data = [];
    this.all_total_data = [];
    this.disableTarif = false;
    this.disableVolume = false;
    // загружаем данные для текущего пресета
    if (this.preset_service.currentPreset && this.preset_service.currentPreset.id_cut && this.preset_service.currentPreset.id_eco_facility) {
      // Загрузка параметра strict_tariff_calc
      try {
        const cutResp = await CutService.getById(this.preset_service.currentPreset.id_cut);
        if (cutResp && cutResp.data) {
          this.strictTariffCalc = !!cutResp.data.strong_tariff_calc;
        } else {
          this.strictTariffCalc = false;
        }
      } catch (e) {
        this.strictTariffCalc = false;
      }
      // Отображать только месяцы соответствующие времени жизни выбранного объекта
      this.set_periods = this.preset_service.period_filtered;
      this.selected_periods = this.preset_service.currentPreset.period;
      this.block_ds = this.totalBlockHeader.concat(this.showBlocks);

      this.totalData = this.createTotalStructure();
      this.purchaseData = this.createStructure();
      this.totalCount = _.cloneDeep(this.totalData);
      let cut_ids = [this.preset_service.currentPreset.id_cut,]

      if (this.preset_service.currentPreset.id_secondary_cut) {
        this.secondaryTotalData = this.createTotalStructure();
        this.secondaryData = this.createStructure();
        cut_ids.push(this.preset_service.currentPreset.id_secondary_cut);
        this.secondaryCutIsVisible = true;
      } else {
        this.secondaryData = {};
        this.secondaryTotalData = {};
        this.secondaryCutIsVisible = false;
      }

      let resp: any;
      let total_resp: any;

      const loadResp = async () => {
        if (this.preset_service.currentPreset.id_eco_facility)
          resp = await this.service.getWithFilter(cut_ids, this.preset_service.currentPreset.id_eco_facility, this.months);
      }

      const loadTotalResp = async () => {
        if (this.preset_service.currentPreset.id_eco_facility)
          total_resp = await this.service.getTotalWithFilter(cut_ids, this.preset_service.currentPreset.id_eco_facility, this.set_periods);
      }

      await Promise.all([this.getTariffs(cut_ids), this.getContractors(cut_ids), loadResp(), loadTotalResp()]);

      if (!this.allTariffs || this.allTariffs.length === 0 || !this.allContractor || this.allContractor.length === 0) {
        this.showNoTariffs = true;
        this.loading_animation = false;
        this.tableStructureReady = false;
        return;
      }

      if (resp) {
        if (resp[this.preset_service.currentPreset.id_cut]) this.all_purchase_data = resp[this.preset_service.currentPreset.id_cut] || [];
        if (this.preset_service.currentPreset.id_secondary_cut) {
          this.all_secondary = resp[this.preset_service.currentPreset.id_secondary_cut] || [];
          for (let purchase_second of this.all_secondary) {
            const tariff = this.secondaryTariffs[purchase_second.id_tarif];
            if (tariff?.two_part) {
              this.showPowerColumns = true;
              break;
            }
          }
        }
      }

      if (!this.showPowerColumns) {
        for (let purchase of this.all_purchase_data) {
          const tariff = this.tariffs[purchase.id_tarif];
          if (tariff?.two_part) {
            this.showPowerColumns = true;
            break;
          }
        }
      }

      if (total_resp) {
        if (total_resp[this.preset_service.currentPreset.id_cut]) this.all_total_data = total_resp[this.preset_service.currentPreset.id_cut];
        if (this.preset_service.currentPreset.id_secondary_cut) {
          this.all_secondary_total = total_resp[this.preset_service.currentPreset.id_secondary_cut];
        }
      }

      const accept_resp = acceptService.GetAcceptDict();
      if (accept_resp && (this.preset_service.currentPreset.id_cut in accept_resp)) {
        let object_id = this.preset_service.currentPreset.id_eco_facility;
        this.currentAccept = accept_resp[this.preset_service.currentPreset.id_cut].filter((acc: Accept) => acc.id_eco_facility === object_id);

        this.currentAccept.forEach((acc: AcceptData) => {
          // Обработка акцепта тарифов
          if (acc.blocks?.blocks__purchase__tariff) {
            this.disableTarif = true;
          }
          // Обработка акцепта объема
          if (acc.blocks?.blocks__purchase__volume) {
            this.disableVolume = true;
          }
          // Проверка валидности месяца
          if (acc.month && this.set_periods.includes(this.month[acc.month])) {
            this.acceptPeriods[this.month[acc.month]] = {
              tarif: !!acc.blocks?.blocks__purchase__tariff,
              volume: !!acc.blocks?.blocks__purchase__volume,
            };
          }
        });
      }

      if (this.route && this.preset_service.currentPreset.id_eco_heat_node) {
        this.allowEditTariff = UserAccessService.checkEditingTariff(this.route, this.preset_service.currentPreset.id_eco_heat_node);
        this.allowEditVolume = UserAccessService.checkEditingVolume(this.route, this.preset_service.currentPreset.id_eco_heat_node);
        this.allowAddRows = UserAccessService.checkEditingRow(this.preset_service.currentPreset.id_eco_heat_node);
      }

      this.parseTotalData(this.totalData, this.all_total_data);
      if (this.all_secondary_total && this.secondaryTotalData) {
        this.parseTotalData(this.secondaryTotalData, this.all_secondary_total);
      }
      for (const block of this.block_ds) {
        this.$set(this.rowVisible, block.name, this.checkEmptyRows(block.name));
      }
      this.tableStructureReady = true;

      this.parseData(this.purchaseData, this.all_purchase_data, this.tariffs);
      if (this.all_secondary && this.secondaryData) {
        this.parseData(this.secondaryData, this.all_secondary, this.secondaryTariffs);
      }
      this.currentObject = this.preset_service.currentPreset.id_eco_facility;
      this.preset_service.setPowerAfterLoading(this.showPowerColumns);
      this.oldData = _.cloneDeep(this.purchaseData); // Сохраняем исходные данные для отката изменений в случае чего
      this.reinitializeInputsHeaderTracking();
    }
    // команда на отрисовку таблицы, также для инпутов разрещается эмитить событие изменения данных
    Vue.nextTick(() => {
      this.startLoading = true;
    });
    setTimeout(() => {
      this.loading_animation = false;
      this.changed = [];
    }, 500);
    sessionStorage.setItem(`inputLoadedData_${this.route}`, 'true');

  }

  async getContractors(cut_ids: string[]) {
    if (this.preset_service.currentPreset && this.preset_service.currentPreset.id_cut && this.preset_service.currentPreset.id_eco_heat_node) {
      const response: any = await ContractorService.getFew(cut_ids, this.preset_service.currentPreset.id_eco_heat_node);
      if (response.data && response.data[this.preset_service.currentPreset.id_cut]) {
        this.allContractor = response.data[this.preset_service.currentPreset.id_cut].filter((contr: Contractor) => contr.purchase === true);
        if (this.preset_service.currentPreset.id_secondary_cut && response.data[this.preset_service.currentPreset.id_secondary_cut]) {
          this.allSecondaryContractor = response.data[this.preset_service.currentPreset.id_secondary_cut].filter((contr: Contractor) => contr.purchase === true);
        }
      }
    }
  }

  async getTariffs(cut_ids: string[]) {
    if (this.preset_service.currentPreset && this.preset_service.currentPreset.id_cut && this.preset_service.currentPreset.id_eco_heat_node) {
      const response = await TariffService.getFew(cut_ids, this.preset_service.currentPreset.id_eco_heat_node);
      if (response.data) {
        this.allTariffs = response.data[this.preset_service.currentPreset.id_cut];
        if (this.allTariffs && this.allTariffs.length > 0) {
          this.allTariffs.forEach((tariff: Tariff) => {
            if (tariff.id) this.tariffs[tariff.id] = tariff;
          });
          this.viewTariffs = this.allTariffs.filter((t: Tariff) => t.view === "Тариф");
          this.viewPrices = this.allTariffs.filter((t: Tariff) => t.view === "Цена");
          if (this.preset_service.currentPreset.id_secondary_cut) {
            this.allSecondaryTariffs = response.data[this.preset_service.currentPreset.id_secondary_cut];
            if (this.allSecondaryTariffs && this.allSecondaryTariffs.length > 0) {
              this.allSecondaryTariffs.forEach((tariff: Tariff) => {
                if (tariff.id) this.secondaryTariffs[tariff.id] = tariff;
              });
            }
          }
        } else {
          return
        }
      }
    }
  }

  addNewData(blockName: string, preset: UserPreset) {
    let listPeriods = this.aggregatePeriods.length > 0 ? this.months.concat(this.aggregatePeriods) : this.months;
    listPeriods.forEach((month: any) => {
      const data: UniversalData = new UniversalData();
      data.block = blockName;
      if (preset.id_cut) data.id_cut = preset.id_cut;
      if (preset.id_eco_facility) data.id_eco_facility = preset.id_eco_facility;
      if (preset.id_eco_heat_node) data.id_eco_heat_node = preset.id_eco_heat_node;
      data.month = month;
      if (this.purchaseData[blockName][month]) {
        this.purchaseData[blockName][month].unshift(data)
      } else {
        this.purchaseData[blockName][month] = [];
        this.purchaseData[blockName][month].unshift(data)
      }
      // Добавляем новую строку в oldData
      if (!this.oldData[blockName]) {
        this.oldData[blockName] = {};
      }
      if (!this.oldData[blockName][month]) {
        this.oldData[blockName][month] = [];
      }
      const oldDataCopy = _.cloneDeep(data);
      this.oldData[blockName][month].unshift(oldDataCopy);
    })
  }

  giveName(names: any) {
    this.mainCutName = names.name;
    this.secondaryCutName = names.secondary;
  }

  handleSecondaryCutInfo(info: any) {
    console.log('handleSecondaryCutInfo called with:', info);
    if (info.hasSecondaryCut && info.secondaryCut) {
      this.secondaryCutIsVisible = true;
      this.secondaryCutName = info.secondaryCut.name;
      // Загружаем данные по дополнительной срезке
      this.loadSecondaryCutData(info.secondaryCutId);
    } else {
      this.secondaryCutIsVisible = false;
      this.secondaryCutName = '';
      this.secondaryData = {};
      this.secondaryTotalData = {};
    }
  }

  async loadSecondaryCutData(secondaryCutId: string) {
    if (this.preset_service.currentPreset.id_eco_facility && secondaryCutId) {
      console.log('Loading secondary cut data for:', secondaryCutId);
      this.secondaryTotalData = this.createTotalStructure();
      this.secondaryData = this.createStructure();

      // Загружаем данные покупки для доп. срезки
      const resp = await this.service.getWithFilter([secondaryCutId], this.preset_service.currentPreset.id_eco_facility, this.months);
      if (resp && (resp as any)[secondaryCutId]) {
        this.all_secondary = (resp as any)[secondaryCutId] || [];
      }

      // Загружаем итоговые данные для доп. срезки
      const total_resp = await this.service.getTotalWithFilter([secondaryCutId], this.preset_service.currentPreset.id_eco_facility, this.set_periods);
      if (total_resp && (total_resp as any)[secondaryCutId]) {
        this.all_secondary_total = (total_resp as any)[secondaryCutId];
      }

      // Загружаем тарифы и контрагентов для доп. срезки
      await Promise.all([this.getTariffs([secondaryCutId]), this.getContractors([secondaryCutId])]);

      console.log('Secondary cut data loaded:', this.all_secondary);
    }
  }

  getBlocks({ blocks, facilityName }: { blocks: any, facilityName: string }) {
      this.facilityName = facilityName;
      this.showNoBlocks = Object.values(blocks).every(arr => (arr as any[]).length === 0);

      let result: any[] = [];
      if(blocks.purchase_blocks.length) {
        this.block_dict.forEach((block: any) => {
          blocks.purchase_blocks.forEach((show_block: any) => {
            if(show_block.block === block.name) result.push(block);
          });
        });
      }
      this.showBlocks = result;
    }

  @Watch('purchaseData', {deep: true})
  countPurchase() {

    this.calculatePurchase(this.purchaseData, this.totalData);
    if (this.all_secondary.length > 0) {
      for (let purchase_second of this.all_secondary) {
        const tariff = this.secondaryTariffs[purchase_second.id_tarif];
        if (tariff?.two_part) {
          this.showPowerColumns = true;
          break;
        }
      }
    }
  }

  calculateAgg(target: any) {
    if (this.aggregatePeriods.length > 0) {
      this.aggregatePeriods.forEach((period: string) => {
        for (let block in target) {
          for (let i = 0; i < target[block]['january'].length; i++) {
            const row = new UniversalData();
            row.id_contractor = target[block]["january"][i].id_contractor;
            row.id_tarif = target[block]["january"][i].id_tarif;
            console.log("ididididididid", target[block]["january"][i].contractor_instance_id)
            row.contractor_instance_id = target[block]["january"][i].contractor_instance_id;
            row.tariff_instance_id = target[block]["january"][i].tariff_instance_id;
            for (let month in aggregate_periods[period]) {
              const month_name = aggregate_periods[period][month];
              row.vol_te += target[block][month_name][i].vol_te;
              row.vol_power += target[block][month_name][i].vol_power;
              row.cost_te += target[block][month_name][i].cost_te;
              row.cost_power += target[block][month_name][i].cost_power;
              row.cost_delta_power += target[block][month_name][i].cost_delta_power;
              row.cost_delta_te += target[block][month_name][i].cost_delta_te;
              row.cost_total += target[block][month_name][i].cost_total;
            }
            target[block][period].splice(i, 1, row);
          }
        }
      });
    }
  }

  @Watch('secondaryData', {deep: true})
  countSecondaryPurchase() {
    this.calculatePurchase(this.secondaryData, this.secondaryTotalData);
  }

  calculatePurchase(data: any, totalData: any) {
    if (this.startLoading) {
      this.showPowerColumns = false;
      // обнуляем массив отслеживания редактирования тарифов
      this.tariffIds = [];
      for (let block in data) {
        let blockSum = _.cloneDeep(this.totalCount[block]);
        this.selected_periods.forEach((period: string) => {
          data[block][period].forEach((p: Purchase) => {
            let tarif = this.tariffs[p.id_tarif];
            if (tarif) {
              // если тариф отсутствует в масиве отслеживания редактирования тарифов, добавляем его туда
              if (!this.tariffIds.includes(p.id_tarif)) {
                this.tariffIds.push(p.id_tarif);
              }
              if (tarif.two_part) this.showPowerColumns = true;
              const row = this.keys.find(k => k.id === tarif.id_heat_carrier);
              if (row) {
                blockSum[period][row.name].vol_te += p.vol_te;
                blockSum[period][row.name].cost_te += p.cost_te;
                blockSum[period][row.name].vol_power += p.vol_power;
                blockSum[period][row.name].cost_power += p.cost_power;
                blockSum[period][row.name].cost_delta_power += p.cost_delta_power;
                blockSum[period][row.name].cost_delta_te += p.cost_delta_te;
                blockSum[period][row.name].price_te = (blockSum[period][row.name].cost_te + blockSum[period][row.name].cost_delta_te) / blockSum[period][row.name].vol_te || 0;
                blockSum[period][row.name].price_power = (blockSum[period][row.name].cost_power + blockSum[period][row.name].cost_delta_power) * 1000 / blockSum[period][row.name].vol_power || 0;
                blockSum[period][row.name].cost_total += p.cost_total;
                blockSum[period][row.name].price_total = (blockSum[period][row.name].cost_total + blockSum[period][row.name].cost_delta_te + blockSum[period][row.name].cost_delta_power) /
                  (blockSum[period][row.name].vol_te + blockSum[period][row.name].vol_power / 1000) || 0;
                  blockSum[period][row.name].contractor_instance_id = p.contractor_instance_id
                  blockSum[period][row.name].tariff_instance_id = p.tariff_instance_id
              }
            }
          });
        });
        for (let period in blockSum) {
          for (let key in blockSum[period]) {
            if (!(key === 'total' || key === 'steam_total')) {
              totalData[block][period][key].vol_te = blockSum[period][key].vol_te;
              totalData[block][period][key].cost_te = blockSum[period][key].cost_te;
              totalData[block][period][key].vol_power = blockSum[period][key].vol_power;
              totalData[block][period][key].cost_power = blockSum[period][key].cost_power;
              totalData[block][period][key].cost_delta_te = blockSum[period][key].cost_delta_te;
              totalData[block][period][key].cost_delta_power = blockSum[period][key].cost_delta_power;
              totalData[block][period][key].price_te = (totalData[block][period][key].cost_te + totalData[block][period][key].cost_delta_te) / totalData[block][period][key].vol_te || 0;
              totalData[block][period][key].price_power = (totalData[block][period][key].cost_power + totalData[block][period][key].cost_delta_power) * 1000 / totalData[block][period][key].vol_power || 0;
              totalData[block][period][key].cost_total = blockSum[period][key].cost_total;
              totalData[block][period][key].price_total = (totalData[block][period][key].cost_total + totalData[block][period][key].cost_delta_te + totalData[block][period][key].cost_delta_power) /
                (totalData[block][period][key].vol_te + totalData[block][period][key].vol_power / 1000) || 0;
                 totalData[block][period][key].contractor_instance_id = blockSum[period][key].contractor_instance_id
                 totalData[block][period][key].tariff_instance_id = blockSum[period][key].tariff_instance_id
            }
          }
        }
      }
    }
  }

  @Watch('totalData.vendors', {deep: true})
  @Watch('totalData.vno', {deep: true})
  @Watch('totalData.vgo', {deep: true})
  @Watch('totalData.vgo23', {deep: true})
  countTotalSum() {
    this.calculateAgg(this.purchaseData);
    this.calculateTotalSum(this.totalData);
  }

  @Watch('secondaryTotalData.vendors', {deep: true})
  @Watch('secondaryTotalData.vno', {deep: true})
  @Watch('secondaryTotalData.vgo', {deep: true})
  @Watch('secondaryTotalData.vgo23', {deep: true})
  countSecondaryTotalSum() {
    this.calculateAgg(this.secondaryData);
    this.calculateTotalSum(this.secondaryTotalData)
  }

  calculateTotalSum(data: any) {
    if (this.startLoading) {
      let totalSum = _.cloneDeep(this.totalCount.total);
      this.block_ds.forEach((block: any) => {
        if (!(block.name === 'total')) {
          this.selected_periods.forEach((period: string) => {
            for (let key in data[block.name][period]) {
              if (!(key === 'total' || key === 'steam_total')) {
                totalSum[period][key].vol_te += data[block.name][period][key].vol_te;
                totalSum[period][key].cost_te += data[block.name][period][key].cost_te;
                totalSum[period][key].vol_power += data[block.name][period][key].vol_power;
                totalSum[period][key].cost_power += data[block.name][period][key].cost_power;
                totalSum[period][key].cost_delta_te += data[block.name][period][key].cost_delta_te;
                totalSum[period][key].cost_delta_power += data[block.name][period][key].cost_delta_power;
                totalSum[period][key].price_te = (totalSum[period][key].cost_te + totalSum[period][key].cost_delta_te) / totalSum[period][key].vol_te || 0;
                totalSum[period][key].price_power = (totalSum[period][key].cost_power + totalSum[period][key].cost_delta_power) * 1000 / totalSum[period][key].vol_power || 0;
                totalSum[period][key].cost_total = totalSum[period][key].cost_total;
                totalSum[period][key].price_total = (totalSum[period][key].cost_total + totalSum[period][key].cost_delta_power + totalSum[period][key].cost_delta_te) /
                  (totalSum[period][key].vol_te + totalSum[period][key].vol_power / 1000) || 0;
                  totalSum[period][key].contractor_instance_id = data[block.name][period][key].contractor_instance_id;
                  totalSum[period][key].tariff_instance_id = data[block.name][period][key].tariff_instance_id;
              }
            }
          });
        }
      });
      for (let period in totalSum) {
        for (let key in totalSum[period]) {
          if (!(key === 'total' || key === 'steam_total')) {
            data.total[period][key].vol_te = totalSum[period][key].vol_te;
            data.total[period][key].cost_te = totalSum[period][key].cost_te;
            data.total[period][key].vol_power = totalSum[period][key].vol_power;
            data.total[period][key].cost_power = totalSum[period][key].cost_power;
            data.total[period][key].cost_delta_te = totalSum[period][key].cost_delta_te;
            data.total[period][key].cost_delta_power = totalSum[period][key].cost_delta_power;
            data.total[period][key].price_te = (data.total[period][key].cost_te + data.total[period][key].cost_delta_te) / data.total[period][key].vol_te || 0;
            data.total[period][key].price_power = (data.total[period][key].cost_power + data.total[period][key].cost_delta_power) * 1000 / data.total[period][key].vol_power || 0;
            data.total[period][key].cost_total = totalSum[period][key].cost_total;
            data.total[period][key].price_total = (data.total[period][key].cost_total + data.total[period][key].cost_delta_te + data.total[period][key].cost_delta_power) /
              (data.total[period][key].vol_te + data.total[period][key].vol_power / 1000) || 0;
              data.total[period][key].contractor_instance_id = totalSum[period][key].contractor_instance_id;
            data.total[period][key].tariff_instance_id = totalSum[period][key].tariff_instance_id;
          }
        }
      }
    }
  }

  get cssVars() {
    return {
      '--width': this.preset_service.cardWidth + 'px'
    }
  }

  public forceReload: boolean = false;

  @Watch('changed')
  saveWatcher() {
    if (this.changed.length > 0) {
      this.disableSave = false;
    } else {
      this.disableSave = true;
    }
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    if (this.loading_animation) {
      // Во время сохранения данных не сразу выполнять переход на следующую, а дождаться выполнения сохранения
      let tickCount = 0;
      const intId = setInterval(() => {
        tickCount++
        // ТАккже предосмотреть выход по истечении заданного интервала
        if (!this.loading_animation || tickCount > 20) {
          clearInterval(intId)
          next()
        }
      }, 200)
    } else if (this.changed.length > 0) {
      confirm('Имеются несохранённые изменения. Сохранить?', 'Сохранение')
        .then((answer: boolean) => {
          if (answer) {
            this.onSave();
            next();
          } else {
            next();
          }
        });
    } else {
      next();
    }
  }

  checkForceReload(flag: boolean) {
    this.forceReload = flag;
  }

  hideExcelHint() {
    this.showExcelHint = false;
  }

  // Метод для обработки запросов на вставку от дочерних компонентов
  handlePasteRequest(pasteInfo: any) {
    console.log('Получен запрос на вставку:', pasteInfo);

    const {matrix, blockId, periodName, startRow, startCol, focusedColumn} = pasteInfo;
    console.log('focusedColumn', focusedColumn);

    // Определяем, нужно ли распространить вставку на другие блоки
    // Теперь применяем глобальную вставку для всех случаев, кроме одиночного значения
    const rows = matrix.length;
    const cols = matrix[0]?.length || 0;
    this.changesLengthBeforePaste = rows * cols;
    const shouldSpreadToOtherBlocks = (rows > 0 || cols > 0);

    if (shouldSpreadToOtherBlocks) {
      // Устанавливаем глобальные параметры вставки
      this.globalPasteData = matrix;
      this.globalPasteStartRow = startRow;
      this.globalPasteStartCol = startCol;
      this.globalPasteTargetBlock = blockId;
      this.globalPasteTargetPeriod = periodName;
      this.globalPasteFocusedColumn = focusedColumn;
      // Применяем вставку ко всем подходящим блокам
      this.applyGlobalPaste();
    }
  }

  // Метод для применения глобальной вставки
  applyGlobalPaste() {
    if (!this.globalPasteData || !this.globalPasteTargetBlock || !this.globalPasteTargetPeriod) {
      return;
    }

    console.log(`Применение глобальной вставки: ${this.globalPasteData.length}x${this.globalPasteData[0]?.length || 0}`);

    // Определяем тип вставки
    const rows = this.globalPasteData.length;
    const cols = this.globalPasteData[0]?.length || 0;

    // Применяем матричную вставку
    this.applyMatrixGlobalPaste();

    // Очищаем глобальные параметры вставки
    this.clearGlobalPaste();
  }

  // Метод для применения значения к конкретной строке блока
  applyValueToBlockRow(blockName: string, periodName: string, rowIndex: number, value: number, targetColumn: string) {
    if (!this.purchaseData[blockName] || !this.purchaseData[blockName][periodName]) {
      return;
    }

    const targetRow = this.purchaseData[blockName][periodName][rowIndex];
    console.log(`  Целевой ряд для ${blockName}.${periodName}.строка[${rowIndex}]:`, targetRow);
    if (targetRow) {
      const periodAccept = this.acceptPeriods?.[periodName] || {};
      const volumeReadOnly = !!periodAccept.volume;
      const tarifReadOnly = !!periodAccept.tarif;
      const costReadOnly = this.strictTariffCalc || (volumeReadOnly && tarifReadOnly);

      const isVolumeColumn = targetColumn === 'vol_te' || targetColumn === 'vol_power';
      const isCostColumn = targetColumn === 'cost_te' || targetColumn === 'cost_power';
      const requiresTwoPart = targetColumn === 'vol_power' || targetColumn === 'cost_power';

      if (isCostColumn && this.strictTariffCalc) {
        console.log(`Пропущена вставка в ${targetColumn} (strictTariffCalc=true) для ${blockName}.${periodName}.строка[${rowIndex}]`);
        return;
      }

      const hasContractor = !!targetRow.id_contractor;
      const hasTariff = !!targetRow.id_tarif;
      const tariff = hasTariff ? this.tariffs[targetRow.id_tarif] : null;
      const isTwoPart = !!tariff?.two_part;

      const isVolumeEditable = this.allowEditVolume && !volumeReadOnly;
      const isCostEditable = (this.allowEditTariff || this.allowEditVolume) &&
        !costReadOnly &&
        (targetColumn !== 'cost_te' || !volumeReadOnly);

      if (!hasContractor || !hasTariff) {
        console.log(`Пропуск вставки в ${targetColumn}: нет контрагента или тарифа для ${blockName}.${periodName}.строка[${rowIndex}]`);
        return;
      }

      if (requiresTwoPart && !isTwoPart) {
        console.log(`Пропуск вставки в ${targetColumn}: тариф не двухставочный для ${blockName}.${periodName}.строка[${rowIndex}]`);
        return;
      }

      if (isVolumeColumn && !isVolumeEditable) {
        console.log(`Пропуск вставки в ${targetColumn}: нет прав или объём акцептирован для ${blockName}.${periodName}.строка[${rowIndex}]`);
        return;
      }

      if (isCostColumn && !isCostEditable) {
        console.log(`Пропуск вставки в ${targetColumn}: нет прав или стоимость заблокирована для ${blockName}.${periodName}.строка[${rowIndex}]`);
        return;
      }

      if (typeof value === 'number' && !isNaN(value) && isFinite(value)) {
        (targetRow as any)[targetColumn] = value;
        console.log(`Применено значение ${value} к ${targetColumn} в ${blockName}.${periodName}.строка[${rowIndex}]`);
      } else {
        (targetRow as any)[targetColumn] = 0;
        console.log(`Некорректное значение ${value}, установлено 0 к ${targetColumn} в ${blockName}.${periodName}.строка[${rowIndex}]`);
      }
    }
  }

  applyMatrixGlobalPaste() {
    if (!this.globalPasteData) return;

    const rows = this.globalPasteData.length;
    const cols = this.globalPasteData[0]?.length || 0;

    console.log(`Матричная вставка: ${rows}x${cols} начиная с позиции (${this.globalPasteStartRow}, ${this.globalPasteStartCol})`);


    console.log('Интерпретация: строки = строки данных, столбцы = периоды');
    this.applyMatrixAsRowsAndPeriods();
  }
  applyMatrixAsRowsAndPeriods() {
    if (!this.globalPasteData) return;

    const rows = this.globalPasteData.length;
    const cols = this.globalPasteData[0]?.length || 0;

    console.log(`Применение матрицы как строки и периоды: ${rows}x${cols}`);
    console.log(`Целевой блок: ${this.globalPasteTargetBlock}, целевой период: ${this.globalPasteTargetPeriod}`);
    console.log(`Начальная строка: ${this.globalPasteStartRow}, начальный столбец: ${this.globalPasteStartCol}`);
    console.log(`Доступные блоки:`, this.block_ds.map(b => b.name));
    console.log(`Доступные периоды:`, this.selected_periods);

    const showVolume = this.preset_service.currentPreset?.buy_show_volume ?? true;
    const showCost = this.preset_service.currentPreset?.buy_show_cost ?? false;
    const effectiveShowCost = this.strictTariffCalc ? false : showCost;
    const showPower = this.showPowerColumns;
    const focusedColumn = this.globalPasteFocusedColumn || '';
    const powerFocused = focusedColumn === 'vol_power' || focusedColumn === 'cost_power';

    const columnsOrder: string[] = [];
    if (powerFocused) {
      if (!showPower) {
        console.log('Вставка пропущена: столбцы мощности скрыты');
        return;
      }
      if (showVolume) columnsOrder.push('vol_power');
      if (effectiveShowCost) columnsOrder.push('cost_power');
    } else {
      if (showVolume) columnsOrder.push('vol_te');
      if (effectiveShowCost) columnsOrder.push('cost_te');
      if (showPower) {
        if (showVolume) columnsOrder.push('vol_power');
        if (effectiveShowCost) columnsOrder.push('cost_power');
      }
    }

    if (columnsOrder.length === 0) {
      console.log('Вставка пропущена: нет доступных столбцов для ввода');
      return;
    }

    const startColumnIndex = this.globalPasteFocusedColumn
      ? columnsOrder.indexOf(this.globalPasteFocusedColumn)
      : 0;

    const normalizedStartColumnIndex = startColumnIndex >= 0 ? startColumnIndex : 0;
    const columnsPerPeriod = columnsOrder.length;

    // Определяем целевой блок для проверки
    const targetBlock = this.block_ds.length === 1
      ? this.block_ds[0]
      : this.block_ds.find(b => b.name === this.globalPasteTargetBlock);

    // Проверка для блока ВНО: нельзя изменять vol_te и cost_te одновременно
    if (targetBlock && targetBlock.name === 'vno' && columnsPerPeriod > 1) {
      // Проверяем, затрагивает ли вставка оба типа столбцов
      let hasVolteChange = false;
      let hasCostChange = false;

      for (let rowIndex = 0; rowIndex < rows; rowIndex++) {
        for (let colIndex = 0; colIndex < cols; colIndex++) {
          const absoluteColumnIndex = normalizedStartColumnIndex + colIndex;
          const columnIndexInPeriod = absoluteColumnIndex % columnsPerPeriod;
          const targetColumn = columnsOrder[columnIndexInPeriod];

          if (targetColumn === 'vol_te' || targetColumn === 'vol_power') {
            hasVolteChange = true;
          } else if (targetColumn === 'cost_te' || targetColumn === 'cost_power') {
            hasCostChange = true;
          }

          // Если оба типа найдены, можно прервать проверку
          if (hasVolteChange && hasCostChange) {
            break;
          }
        }
        if (hasVolteChange && hasCostChange) {
          break;
        }
      }

      // Если вставка затрагивает и vol_te, и cost_te одновременно - отменяем
      if (hasVolteChange && hasCostChange) {
        alert('В блоке ВНО невозможно изменить Объём и Стоимость одновременно', 'Ошибка');
        this.clearGlobalPaste();
        return;
      }
    }

    console.log(`Видимость: volume=${showVolume}, cost=${showCost}, power=${showPower}, strictTariffCalc=${this.strictTariffCalc}, столбцов на период=${columnsPerPeriod}`);
    console.log(`Начальный столбец: ${this.globalPasteFocusedColumn}, индекс=${normalizedStartColumnIndex}`);

    const startPeriodIndex = this.selected_periods.findIndex((period: any) => period === this.globalPasteTargetPeriod);

    // Применяем данные построчно
    for (let rowIndex = 0; rowIndex < rows; rowIndex++) {
      // rowIndex определяет строку данных
      const targetRowIndex = this.globalPasteStartRow + rowIndex;
      const row = this.globalPasteData[rowIndex];

      console.log(`Обработка строки ${rowIndex}: строка данных ${targetRowIndex}, значения [${row.join(', ')}]`);

      for (let colIndex = 0; colIndex < cols; colIndex++) {
        const absoluteColumnIndex = normalizedStartColumnIndex + colIndex;
        const targetPeriodIndex = startPeriodIndex + Math.floor(absoluteColumnIndex / columnsPerPeriod);
        const columnIndexInPeriod = absoluteColumnIndex % columnsPerPeriod;
        const targetColumn = columnsOrder[columnIndexInPeriod];

        if (targetPeriodIndex >= 0 && targetPeriodIndex < this.selected_periods.length) {
          const targetPeriod = this.selected_periods[targetPeriodIndex];
          const value = row[colIndex];

          // Если у нас только один блок, применяем все значения к нему
          if (this.block_ds.length === 1) {
            const targetBlock = this.block_ds[0];

            console.log(`  Столбец ${colIndex}: период ${targetPeriod}, блок ${targetBlock.name}, значение ${value}, колонка=${targetColumn}`);

            // Применяем значение к соответствующей строке в целевом блоке и периоде
            this.applyValueToBlockRow(targetBlock.name, targetPeriod, targetRowIndex, value, targetColumn);
          } else {
            // Если несколько блоков, ищем по индексу
            const targetBlockIndex = this.block_ds.findIndex(block => block.name === this.globalPasteTargetBlock);
            console.log(`  Столбец ${colIndex}: целевой блок индекс ${targetBlockIndex}`);

            if (targetBlockIndex >= 0 && targetBlockIndex < this.block_ds.length) {
              const targetBlock = this.block_ds[targetBlockIndex];

              console.log(`  Столбец ${colIndex}: период ${targetPeriod}, блок ${targetBlock.name}, значение ${value}, колонка=${targetColumn}`);

              // Применяем значение к соответствующей строке в целевом блоке и периоде
              this.applyValueToBlockRow(targetBlock.name, targetPeriod, targetRowIndex, value, targetColumn);
            } else {
              console.log(`  Столбец ${colIndex}: блок с индексом ${targetBlockIndex} не найден`);
            }
          }
        } else {
          console.log(`Столбец ${colIndex}: период с индексом ${targetPeriodIndex} не найден`);
        }
      }
    }
  }

  // Метод для очистки глобальных параметров вставки
  clearGlobalPaste() {
    this.globalPasteData = null;
    this.globalPasteStartRow = 0;
    this.globalPasteStartCol = 0;
    this.globalPasteTargetBlock = null;
    this.globalPasteTargetPeriod = null;
    this.globalPasteFocusedColumn = null;
  }

  tarifChangeHandler(idx: number, newTariff: string, oldTariff: string, block: string) {
    if (!_.isNil(idx)) {
      this.needRecalc = null;
      this.choiсe = null;
      this.tariffForRollback = oldTariff;
      this.choicePopup.idx = idx;
      this.choicePopup.block = block;
      this.choicePopup.tariff = newTariff;
      this.choicePopup.visible = true;
    }
  }

  public choicePopup: any = {
    visible: false,
    idx: null,
    block: '',
    tariff: ''
  }

  choiceHandler(choiсe: string | null, idx: number, block: string) {
    if (_.isNil(choiсe)) {
      for (let i = 0; i < this.months.length; i++) {
        this.purchaseData[block][this.months[i]][idx].id_tarif = this.tariffForRollback;
      }
    } else {
      this.choiсe = choiсe;
      this.needRecalc = idx;
    }
  }

  get noBlocksMessage() {
    const sectionMap: Record<string, string> = {
      losses: 'Потери',
      buy: 'Покупка',
      sale: 'Реализация',
      transport_cost: 'Затраты на транспорт',
      transport_gain: 'Выручка за транспорт'
    };
    const routeName = this.$route && this.$route.name ? this.$route.name : '';
    const section = sectionMap[routeName] || routeName;

    return `Для объекта «${this.facilityName}» в разделе «${section}» нет блоков, доступных для заполнения. Обратитесь к администратору.`;
  }

  public hideHeader: boolean = true;

    created() {
      if(!_.isNil(sessionStorage.getItem('hideHeader'))) {
        const match = sessionStorage.getItem('hideHeader');
        if(match) {
          const settings = JSON.parse(match);
          if(settings.user_id === localStorage.getItem('user_id')) this.hideHeader = (settings.state === 'true');
        }
      }
    }

    switchToogle() {
      this.hideHeader = !this.hideHeader;
      sessionStorage.setItem(`hideHeader`, `{"user_id": "${localStorage.getItem('user_id')}", "state": "${this.hideHeader}"}`);
    }
}
